import styled from 'styled-components';

export const Svg = styled.svg`
  display: block;
`;
